// React
import { useCallback } from 'react';

// Misc
import { posthog } from '../lib/posthog';

export const useTrackEvent = () => {
  return useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      posthog.capture(event, properties);
    },
    []
  );
};
